
import { useQuery } from "@tanstack/react-query";
import { fetchCategories } from "@/services/reagentService";

export const useCategories = () => {
  const { 
    data: categories = [], 
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
    staleTime: 1000 * 60 * 30, // 30 minutes
    refetchOnWindowFocus: false,
  });

  return {
    categories,
    isLoading,
    error,
    refetch
  };
};
